import type React from 'react'

type props = { link: string }
export const Footnote: React.FC<props> = ({ link }) => {
  // biome-ignore lint/a11y/useAnchorContent: Not needed for footnote
  return <a target="_blank" rel="noreferrer" className="footnote" href={link} />
}
